import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/templates/default/DefaultTemplate.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Stack`}</h2>
    <ul>
      <li parentName="ul">{`GatsbyJS (Client)`}</li>
      <li parentName="ul">{`GraphQL (Data)`}</li>
      <li parentName="ul">{`MDX (Content)`}</li>
      <li parentName="ul">{`Netlify (Server)`}</li>
      <li parentName="ul">{`TailwindCSS (Styles)`}</li>
      <li parentName="ul">{`TypeScript (Types)`}</li>
    </ul>
    <h2>{`Gatsby`}</h2>
    <p>{`Nova is composed of different gatsby plugins and themes.`}</p>
    <p>{`For info about gatsby plugins and themes, see the following:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.gatsbyjs.com/docs/plugins-themes-and-starters/"
        }}>{`Gatsby plugins, themes and starters`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.gatsbyjs.com/docs/plugins/"
        }}>{`Gatsby plugins docs`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.gatsbyjs.com/docs/themes/what-are-gatsby-themes/"
        }}>{`What are gatsby themes?`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.gatsbyjs.com/blog/2020-05-14-introducing-gatsby-theme-catalyst/"
        }}>{`Introducing gatsby theme catalyst`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.gatsbyjs.com/tutorial/plugin-and-theme-tutorials/"
        }}>{`Gatsby plugin and theme tutorials`}</a></li>
    </ul>
    <h3>{`Gatsby Plugins`}</h3>
    <h4>{`Gatsby MDX`}</h4>
    <p>{`MDX with `}<a parentName="p" {...{
        "href": "https://github.com/gatsbyjs/gatsby/tree/master/packages/gatsby-plugin-mdx"
      }}><code parentName="a" {...{
          "className": "language-text"
        }}>{`gatsby-plugin-mdx`}</code></a>{`.`}</p>
    <ul>
      <li parentName="ul">{`Configure plugins and other options in `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`gatsby-config`}</code>{`.`}</li>
      <li parentName="ul">{`Configure render options in `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`components/mdx`}</code></li>
    </ul>
    <h4>{`Gatsby Next SEO`}</h4>
    <p>{`SEO with `}<a parentName="p" {...{
        "href": "https://github.com/ifiokjr/gatsby-plugin-next-seo"
      }}><code parentName="a" {...{
          "className": "language-text"
        }}>{`gatsby-plugin-next-seo`}</code></a>{`.`}</p>
    <ul>
      <li parentName="ul">{`Configure defaults in `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`gatsby-config`}</code>{`.`}</li>
      <li parentName="ul">{`Configure page level SEO in `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`pages`}</code>{` by passing `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`seo`}</code>{` props to `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`layouts`}</code>{`.`}</li>
      <li parentName="ul">{`Configure `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`seo`}</code>{` props in the `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`frontmatter`}</code>{` of your `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`mdx/md`}</code>{` files.`}</li>
    </ul>
    <h3>{`Custom Plugins and Themes (Coming Soon)`}</h3>
    <ul>
      <li parentName="ul">{`Components with TailwindCSS`}
        <ul parentName="li">
          <li parentName="ul">{`Compositional UI Components`}</li>
          <li parentName="ul">{`Primitive UI Components`}</li>
          <li parentName="ul">{`Structural UI Components`}</li>
          <li parentName="ul">{`Typography UI Components`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Forms`}
        <ul parentName="li">
          <li parentName="ul">{`Form Container Compositions`}</li>
          <li parentName="ul">{`React Hook Form`}</li>
          <li parentName="ul">{`Mailchimp / Netlify Integration`}</li>
        </ul>
      </li>
      <li parentName="ul">{`MDX`}
        <ul parentName="li">
          <li parentName="ul">{`Blog`}</li>
          <li parentName="ul">{`Case Studies`}</li>
          <li parentName="ul">{`Portfolio`}</li>
          <li parentName="ul">{`Projects`}</li>
        </ul>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      